export default function Block({ children }) {
  return (
    <div className="col m-2 border border-secondary fs-4 text-center">
      <div className="row d-flex flex-row align-items-center dashboard-sponsorship-block bg-white block">
        <div className="col">{children}</div>
      </div>
    </div>
  )
}
